module.exports = __webpack_public_path__ + "img/Bjornson_Politiker_og_folketaler.ceb34bde.jpg";